import { NgModule,CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserModule, HAMMER_GESTURE_CONFIG, HammerModule } from '@angular/platform-browser';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import {CommonServiceService} from './services/common-service.service';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import {CdkStepperModule} from '@angular/cdk/stepper';
import {NgStepperModule} from 'angular-ng-stepper';
import { HttpClientModule,HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SigninComponent,ForgotPasswordDialog } from './signin/signin.component';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import {MatSidenavModule} from '@angular/material/sidenav';
import { HeaderComponent,DialogFromMenuExampleDialog } from './header/header.component';
import { SidenavComponent } from './sidenav/sidenav.component';
import {MatListModule} from '@angular/material/list';
import {MatDialogModule} from '@angular/material/dialog';
import { FlexLayoutModule } from '@angular/flex-layout';
import {MatToolbarModule} from '@angular/material/toolbar';
import {SignUpModule} from './sign-up/sign-up.module';
import {InsightsModule} from './insights/insights.module';
import {BotsModule} from './bots/bots.module';
import { MiniAppssModule } from './mini-apps/miniapps.module';
import { TemplatesModule } from './templates/templates.module';
import { PricingModule } from './pricing/pricing.module';
import { PoliciesModule } from './policies/policies.module';
import { DocumentsModule } from './documents/documents.module';
import {CustomCodeModule} from './custom-code/custom-code.module'
import {MatCardModule} from '@angular/material/card';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatButtonModule} from '@angular/material/button';
import {MatStepperModule} from '@angular/material/stepper';
import {MatRadioModule} from '@angular/material/radio';
import { NgOtpInputModule } from  'ng-otp-input';
import {JwtInterceptor} from './helpers/jwt.interceptor'
import { MatTooltipModule } from '@angular/material/tooltip';
import 'hammerjs'; 
import {MatSelectModule} from '@angular/material/select';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatCheckboxModule} from '@angular/material/checkbox';
import { MatMenuModule} from '@angular/material/menu';
import {MatFormFieldModule} from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatNativeDateModule } from '@angular/material/core';
import {MatIconModule} from '@angular/material/icon';
import { EditProfileComponent,RegenereteApiKeyDialog,VerifyEmailDialog } from './edit-profile/edit-profile.component';
import { ClipboardModule } from 'ngx-clipboard';
import { AlertModule } from './alert/alert.module';
import { LibModule } from './lib/lib.module';
import { AdminModule } from './admin/admin.module';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { NgxHttpLoaderModule } from 'ngx-http-loader';
import { AdminLoginComponent } from './admin-login/admin-login.component';
import {MatRippleModule} from '@angular/material/core';
import { SupportComponent } from './support/support.component';
import { LyHammerGestureConfig, LY_THEME, LY_THEME_NAME, StyleRenderer, LyTheme2 } from '@alyle/ui';
import { MinimaLight } from '@alyle/ui/themes/minima';
import { CKEditor4 } from 'ckeditor4-angular/ckeditor';
import { PostHubModule } from './post-hub/post-hub.module';

@NgModule({
    declarations: [
        AppComponent,
        SigninComponent,
        ResetPasswordComponent,
        HeaderComponent,
        SidenavComponent,
        ForgotPasswordDialog,
        DialogFromMenuExampleDialog,
        EditProfileComponent,
        RegenereteApiKeyDialog,
        AdminLoginComponent,
        VerifyEmailDialog,
        SupportComponent
    ],
    imports: [
        BrowserAnimationsModule,
        BrowserModule,
        MatTooltipModule,
        AppRoutingModule,
        FormsModule,
        ReactiveFormsModule,
        NgbModule,
        NgxDropzoneModule,
        TooltipModule.forRoot(),
        CdkStepperModule,
        NgStepperModule,
        HttpClientModule,
        MatSidenavModule,
        MatListModule,
        MatDialogModule,
        FlexLayoutModule,
        MatToolbarModule,
        SignUpModule,
        InsightsModule,
        BotsModule,
        MiniAppssModule,
        PostHubModule,
        TemplatesModule,
        PricingModule,
        PoliciesModule,
        DocumentsModule,
        CustomCodeModule,
        MatCardModule,
        MatProgressBarModule,
        MatButtonModule,
        MatStepperModule,
        MatDialogModule,
        NgOtpInputModule,
        MatSelectModule,
        MatRadioModule,
        MatSlideToggleModule,
        MatCheckboxModule,
        MatMenuModule,
        MatFormFieldModule,
        MatInputModule,
        MatNativeDateModule,
        MatIconModule,
        ClipboardModule,
        AlertModule,
        LibModule,
        AdminModule,
        MatProgressSpinnerModule,
        NgxHttpLoaderModule.forRoot(),
        MatRippleModule,
        HammerModule
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    providers: [CommonServiceService, { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true }, { provide: HAMMER_GESTURE_CONFIG, useClass: LyHammerGestureConfig }, StyleRenderer, LyTheme2, { provide: LY_THEME_NAME, useValue: 'minima-light' }, { provide: LY_THEME, useClass: MinimaLight, multi: true }],
    bootstrap: [AppComponent]
})
export class AppModule { }
